import { translation } from './../../lang/Translation';
import { AbstractBlock } from '../AbstractBlock';
import { blocklyDispatcher } from '../blocklyDispatcher';
import { DialogHandler } from '../../components/dialog/DialogHandler';
const t = translation;

export class ARMarkerListButton extends AbstractBlock {
  constructor() {
    super('', '');

    // ワークスペースをマウントしたときにイベントをハンドリング
    blocklyDispatcher.addMountedWorkspaceListener(function (workspace) {
      workspace.registerButtonCallback('click_ar_show', () => {
        DialogHandler.showArMarkerListDialog();
      });
      blocklyDispatcher.triggerUpdateToolbox(workspace);
    });
  }

  toXml(): HTMLElement {
    const el = document.createElement('button');
    el.setAttribute('text', t.to('ARマーカーリスト', 'ar_marker_list'));
    el.setAttribute('callbackKey', 'click_ar_show');
    el.setAttribute('web-class', 'ar_marker');
    el.addEventListener('click', () => {
      // console.log('ar marker');
    });
    return el;
    // return  '<button text="グーグルPolyを開く" callbackKey="click_poly_show"></button>'
  }
}
